import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Banner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            listItem: [
                {
                    id: 1,
                    icon: 'fa fa-check',
                    title: 'Proven Tax-Saving Strategies',
                },
                {
                    id: 2,
                    icon: 'fa fa-check',
                    title: 'Maximize Deductions',
                },
                {
                    id: 3,
                    icon: 'fa fa-check',
                    title: 'Step-by-Step Guidance',
                },
                {
                    id: 4,
                    icon: 'fa fa-check',
                    title: 'Compliant with tax laws',
                },
            ]
        }
    }
    render() {
        return (
            <section className="banner pb-80 dark-bg">
                <div className="container">
                    <div className="row align-items-center justify-content-between">
                        <div className="col-lg-6">
                            <div className="banner-img pe-3">
                                <img src="assets/images/banner/book-2.jpg" alt="" className="img-fluid" />
                            </div>
                        </div>
                        <div className="col-md-12 col-lg-6">
                            <div className="banner-content  mt-4 mt-lg-0">
                                <span className="subheading">ExpertEdge Publication's</span>
                                <h1>The Ultimate Tax-Saving Strategies for Salaried Individuals</h1>
                                <ul>
                                    {
                                        this.state.listItem.map(data => (
                                            <li key={data.id}><i className={data.icon}></i> {data.title}</li>
                                        ))
                                    }
                                </ul>
                                <p>Tax planning is an ongoing process. By following the strategies in this eBook and understanding the Finance Act, 2024, you can optimize tax savings, invest wisely, and secure your financial future. You can plan effectively until 31st March 2025</p>
                                <Link to="/payment" className="btn btn-main">Get this book at  ₹ 99</Link>
                                {/* <p>Interested in free chapter? <Link to="#">Get it now</Link></p> */}
                            </div>
                        </div>

                    </div>
                </div>
            </section>

        );
    }
}

export default Banner;

